import { z } from 'zod';

import { GSEName, LoanInvestorName } from '@willow/types-iso';

export const isOwnerIdGSE = (ownerId?: string | null): ownerId is GSEName => z.validate(GSEName, ownerId);

/** Narrower check: true only for traditional investor names (FNMA, FHLMC, GNMA) — excludes FHA */
export const isOwnerIdLoanInvestor = (ownerId?: string | null): ownerId is LoanInvestorName =>
  z.validate(LoanInvestorName, ownerId);
